var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.734,
    height: 26.092,
    viewBox: "0 0 21.734 26.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0.084,
    y2: 0.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09-timer",
    "data-name": "09-timer",
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M26.767,7.764,28.329,6.2,26.792,4.665,25.122,6.335A10.8,10.8,0,0,0,19.954,4.4V2.173h2.173V0h-6.52V2.173H17.78V4.4a10.8,10.8,0,0,0-5.168,1.934L10.942,4.665,9.405,6.2l1.562,1.562a10.867,10.867,0,1,0,15.8,0Zm-7.9,16.144a8.693,8.693,0,1,1,8.693-8.693A8.693,8.693,0,0,1,18.867,23.907Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M27.607,28a1.087,1.087,0,0,0-1.087,1.087V34.52H21.087A1.087,1.087,0,0,0,20,35.607,7.607,7.607,0,1,0,27.607,28Zm0,13.04a5.443,5.443,0,0,1-5.325-4.347h5.325a1.087,1.087,0,0,0,1.087-1.087V30.282A5.433,5.433,0,0,1,27.607,41.04Z",
    transform: "translate(-8.74 -20.393)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipTimer);
export default __webpack_public_path__ + "static/media/clip-timer.ce3202a7038ad38521ab6fb922765b1d.svg";
export { ForwardRef as ReactComponent };